import dayjs from 'dayjs'

export const mockInventoryItems = [
  {
    id: 1,
    name: 'Paracetamol 500mg',
    category: 'Medication',
    currentStock: 1567,
    minimumStock: 200,
    unitPrice: 16.5,
    expiryDate: '2024-12-15',
    initialStock: 2000,
    totalSold: 2850,
    reorderQuantity: 500
  },
  {
    id: 2,
    name: 'Amoxicillin 250mg',
    category: 'Medication',
    currentStock: 500,
    minimumStock: 150,
    unitPrice: 24.75,
    expiryDate: '2024-06-30',
    initialStock: 800,
    totalSold: 950,
    reorderQuantity: 400
  },
  {
    id: 3,
    name: 'Vitamin C 1000mg',
    category: 'Medication',
    currentStock: 1125,
    minimumStock: 100,
    unitPrice: 12.99,
    expiryDate: '2025-03-15',
    initialStock: 1500,
    totalSold: 1800,
    reorderQuantity: 500
  },
  {
    id: 4,
    name: 'Surgical Gloves',
    category: 'Consumables',
    currentStock: 850,
    minimumStock: 200,
    unitPrice: 8.75,
    expiryDate: '2024-08-20',
    initialStock: 1000,
    totalSold: 1400,
    reorderQuantity: 300
  },
  {
    id: 5,
    name: 'Face Masks',
    category: 'PPE',
    currentStock: 600,
    minimumStock: 500,
    unitPrice: 5.99,
    expiryDate: '2024-10-25',
    initialStock: 1000,
    totalSold: 1200,
    reorderQuantity: 500
  },
  {
    id: 6,
    name: 'Blood Pressure Monitor',
    category: 'Equipment',
    currentStock: 45,
    minimumStock: 10,
    unitPrice: 129.99,
    expiryDate: '2028-01-01',
    initialStock: 50,
    totalSold: 5,
    reorderQuantity: 10
  },
  {
    id: 7,
    name: 'Thermometer',
    category: 'Equipment',
    currentStock: 60,
    minimumStock: 15,
    unitPrice: 24.5,
    expiryDate: '2027-06-15',
    initialStock: 75,
    totalSold: 15,
    reorderQuantity: 20
  },
  {
    id: 8,
    name: 'Disposable Syringes',
    category: 'Consumables',
    currentStock: 1475,
    minimumStock: 300,
    unitPrice: 0.75,
    expiryDate: '2024-09-30',
    initialStock: 2000,
    totalSold: 2800,
    reorderQuantity: 1000
  },
  {
    id: 9,
    name: 'Bandages',
    category: 'Consumables',
    currentStock: 800,
    minimumStock: 200,
    unitPrice: 3.25,
    expiryDate: '2025-05-20',
    initialStock: 1000,
    totalSold: 1200,
    reorderQuantity: 300
  },
  {
    id: 10,
    name: 'Antibiotic Ointment',
    category: 'Medication',
    currentStock: 350,
    minimumStock: 75,
    unitPrice: 8.99,
    expiryDate: '2024-07-15',
    initialStock: 500,
    totalSold: 150,
    reorderQuantity: 200
  },
  {
    id: 11,
    name: 'Protective Goggles',
    category: 'PPE',
    currentStock: 230,
    minimumStock: 50,
    unitPrice: 12.99,
    expiryDate: '2026-04-10',
    initialStock: 300,
    totalSold: 350,
    reorderQuantity: 100
  },
  {
    id: 12,
    name: 'Digital Stethoscope',
    category: 'Equipment',
    currentStock: 15,
    minimumStock: 5,
    unitPrice: 199.99,
    expiryDate: '2030-01-01',
    initialStock: 20,
    totalSold: 5,
    reorderQuantity: 5
  },
  {
    id: 13,
    name: 'Surgical Masks',
    category: 'PPE',
    currentStock: 400,
    minimumStock: 200,
    unitPrice: 0.99,
    expiryDate: '2024-11-30',
    initialStock: 1000,
    totalSold: 1800,
    reorderQuantity: 600
  },
  {
    id: 14,
    name: 'Ibuprofen 200mg',
    category: 'Medication',
    currentStock: 725,
    minimumStock: 150,
    unitPrice: 14.75,
    expiryDate: '2024-10-15',
    initialStock: 1000,
    totalSold: 1400,
    reorderQuantity: 400
  },
  {
    id: 15,
    name: 'Surgical Masks N95',
    category: 'PPE',
    currentStock: 15,
    minimumStock: 50,
    unitPrice: 35.99,
    expiryDate: '2024-09-15',
    initialStock: 100,
    totalSold: 85,
    reorderQuantity: 100
  },
  {
    id: 16,
    name: 'Insulin 100ml',
    category: 'Medication',
    currentStock: 5,
    minimumStock: 20,
    unitPrice: 149.5,
    expiryDate: '2024-08-10',
    initialStock: 30,
    totalSold: 25,
    reorderQuantity: 25
  },
  {
    id: 17,
    name: 'Examination Gloves',
    category: 'Consumables',
    currentStock: 100,
    minimumStock: 300,
    unitPrice: 2.5,
    expiryDate: '2025-01-30',
    initialStock: 500,
    totalSold: 400,
    reorderQuantity: 500
  },
  {
    id: 18,
    name: 'Blood Testing Strips',
    category: 'Consumables',
    currentStock: 45,
    minimumStock: 100,
    unitPrice: 8.75,
    expiryDate: '2024-11-05',
    initialStock: 200,
    totalSold: 155,
    reorderQuantity: 150
  },
  {
    id: 19,
    name: 'Sterile Needles',
    category: 'Consumables',
    currentStock: 180,
    minimumStock: 200,
    unitPrice: 1.25,
    expiryDate: '2025-03-15',
    initialStock: 500,
    totalSold: 320,
    reorderQuantity: 300
  }
]

export const mockCategoryData = [
  {
    name: 'Consumables',
    itemCount: 42,
    totalValue: 58760,
    totalStock: 3125,
    averageStock: 74,
    valuePercentage: 28.5
  },
  {
    name: 'Equipment',
    itemCount: 23,
    totalValue: 45200,
    totalStock: 105,
    averageStock: 4,
    valuePercentage: 21.9
  },
  {
    name: 'Medication',
    itemCount: 67,
    totalValue: 78300,
    totalStock: 2450,
    averageStock: 36,
    valuePercentage: 38.0
  },
  {
    name: 'PPE',
    itemCount: 18,
    totalValue: 23900,
    totalStock: 1230,
    averageStock: 68,
    valuePercentage: 11.6
  }
]

export const mockTurnoverData = [
  {
    category: 'Medication',
    turnoverRate: 1.95,
    averageInventory: 1500,
    totalSold: 2925
  },
  {
    category: 'Consumables',
    turnoverRate: 1.4,
    averageInventory: 2200,
    totalSold: 3080
  },
  {
    category: 'PPE',
    turnoverRate: 2.3,
    averageInventory: 800,
    totalSold: 1840
  },
  {
    category: 'Equipment',
    turnoverRate: 0.7,
    averageInventory: 150,
    totalSold: 105
  }
]

export const mockExpiryData = {
  critical: {
    count: 3,
    value: 45678.9
  },
  warning: {
    count: 2,
    value: 23456.78
  },
  attention: {
    count: 5,
    value: 78901.23
  }
}
